export default {
  // 通用
  common: {
    search: 'Search',
    submit: 'Submit',
    cancel: 'Cancel',
    close: 'Close',
    loading: 'Loading...',
    success: 'Success',
    error: 'Error',
    required: 'Required',
    optional: 'Optional'
  },
  
  // 应用标题
  app: {
    title: 'FFXIV Market Board Price Lookup'
  },
  
  // 搜索区域
  search: {
    inputPlaceholder: 'Enter item name',
    noResults: 'No relevant information found'
  },
  
  // 价格表格
  priceTable: {
    headers: {
      pricePerUnit: 'Price per Unit',
      quantity: 'Quantity',
      server: 'Server',
      retainer: 'Retainer',
      total: 'Total'
    }
  },
  
  // 意见反馈
  feedback: {
    title: 'Feedback',
    description: 'Every suggestion you provide helps us improve and create a better experience',
    contentLabel: 'Your opinion or suggestion',
    contentPlaceholder: 'Please describe your opinion or suggestion in detail, we will read every piece of feedback carefully...',
    emailLabel: 'Contact Email',
    emailPlaceholder: 'If you need a reply, please leave your email address',
    emailTooltip: 'We promise to protect your privacy, email is only used for replying to feedback',
    submitButton: 'Submit Feedback',
    processingTime: 'We value every piece of feedback and usually process it within 1-3 business days',
    
    // 验证消息
    validation: {
      contentRequired: 'Please enter your opinion or suggestion',
      contentMinLength: 'Please enter at least 10 characters',
      contentMaxLength: 'Feedback content cannot exceed 500 characters',
      emailInvalid: 'Please enter a valid email address'
    },
    
    // 提示消息
    messages: {
      submitSuccess: 'Feedback submitted successfully, thank you for your input!',
      submitError: 'Failed to submit feedback, please try again later'
    }
  },
  
  // 语言切换
  language: {
    switch: 'Switch Language',
    chinese: '中文',
    english: 'English'
  }
}